<template>
  <filter-controller
    @input="handleFilter"
    :receive="allProps.receive"
    :all="allProps.result"
    :pagination='pagination'
    :loading="allProps.loading"
    :value="value"
    :label="label"
    :needSearch="needSearch"
    :filterKey="filterKey"
  />
</template>

<script>

import ViewMixin from './mixins/ViewMixin'

export default {
  mixins: [ViewMixin],
}

</script>
